import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const productData = this.props.productList;
    const data = this.props.searchData;
    const totalValues = this.props.totalValues;

    return (
      <div style={{ padding: '10px' }}>
        <h3><center><u>Availability against the Requirement - Forecasting</u></center></h3>
        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align={'left'}>SKU Code</TableCell>
                  <TableCell align={'left'}>SKU Description</TableCell>
                  <TableCell align={'right'}>Availability Forecasting</TableCell>
                  <TableCell align={'right'}>Demand Forecasting</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productCode}
                    </TableCell>
                    <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productDescription}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.availabilityForecasting == 0 ? '-' : parseFloat(data.availabilityForecasting).toFixed(2)}
                    </TableCell>
                    <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.demand == 0 ? '-' : parseFloat(data.demand).toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TableCell colSpan={2} align={'left'} sx={{ fontWeight: "bold", fontSize: "15px" }}>Total</TableCell>
                  <TableCell align={'right'} sx={{ fontWeight: "bold", fontSize: "15px" }}>
                    {totalValues.totalForecast == 0 ? '-' : parseFloat(totalValues.totalForecast).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                  <TableCell align={'right'} sx={{ fontWeight: "bold", fontSize: "15px" }}>
                    {totalValues.totalDemand == 0 ? '-' : parseFloat(totalValues.totalDemand).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
        </Box>
      </div>

    );
  }
}
